import React from "react";
import "../../containers/ConfirmOpenTicket.css";

import { translations } from "../../containers/assets/translations";
import { ControlLabel, Button, FormGroup, FormControl } from "react-bootstrap";
import Checkbox from "@material-ui/core/Checkbox";

export default class ReservationDetails extends React.Component {
	
	shouldComponentUpdate(nextProps,nextState){
		if(this.props.shouldResDetailsUpdate === true){
			return true;
		} else { 
			return false;
		}
	}
	
  render() {
    let vehicles = this.props.vehicleTickets;
    let vehicleArraySize = vehicles.length;
	
    return (
	
      <div>
        {this.props.displayReservationResults ? (
          <div>
            <div className="col-md-12 reservationResultsContainer">
              <div className="col-md-1 selectCol reservationHeader">
                Select All
                <Checkbox
                  className="checkboxnonShow"
                  color="primary"
                  checked={this.props.isPersonSelectAllToggled}
                  onClick={() => {
                    this.props.handlePersonSelectAllButton();
                    this.props.handleVehicleSelectAllButton();
                  }}
                />
              </div>
              <div className="col-md-2 reservationHeader2">
                {translations[this.props.lang]["Ticket Number"]}
              </div>
              <div className="col-md-4 reservationHeader2">
                {translations[this.props.lang]["Surname Name"]}
              </div>
              <div className="col-md-3 reservationHeader2">
                {translations[this.props.lang]["Passport / Plates"]}
              </div>
              <div className="col-md-1 reservationHeader2">
                {translations[this.props.lang]["Status"]}
              </div>
            </div>
            {this.props.personTickets.map((personTicket, index) => {
              return (
                <div
                  className="col-md-12 col-xs-12 resultsRTicks"
                  key={personTicket.BookID}
                >
                  <div
                    className="col-md-1 col-xs-1 selectCol"
                    ref={index === 0 ? this.props.myRef : null}
                  >
                    {personTicket.ConfirmationStatus !== "Canceled" ? (
                      <Checkbox
                        color="primary"
                        checked={this.props.selectedPersonTickets[index]}
                        onClick={() => {
                          this.props.handlePersonCheckboxChange(index);
                        }}
                      />
                    ) : (
                      <Checkbox
                        color="primary"
                        disabled
                        checked={this.props.selectedPersonTickets[index]}
                        onClick={() => {
                          this.props.handlePersonCheckboxChange(index);
                        }}
                      />
                    )}
                  </div>
                  <div className="col-md-2 col-xs-4 resultTick">
                    <span className="rowdescr">
                      {translations[this.props.lang]["Ticket Number"]}:
                    </span>
                    {personTicket.TicketNumber}
                  </div>
                  <div className="col-md-4 col-xs-4 resultTick">
                    <span className="rowdescr">
                      {translations[this.props.lang]["Surname Name"]}:
                    </span>
                    {personTicket.Surname} {personTicket.Name}
                    {this.props.isMRZMandatory == 1 && (
                      <strong 
                        style={{ 
                          marginLeft: '12px', 
                          fontSize: '11px', 
                          fontWeight: 'bold', 
                          padding: '2px 8px', 
                          borderRadius: '4px',
                          backgroundColor: personTicket.IsMRZScanned == 1 ? '#2ecc71' : '#e74c3c',
                          color: 'white',
                          display: 'inline-block',
                          verticalAlign: 'middle',
                          textTransform: 'uppercase',
                          letterSpacing: '0.5px'
                        }}
                      >
                        MRZ
                      </strong>
                    )}
                  </div>
                  <div className="col-md-3 col-xs-4 resultTick">
                    <span className="rowdescr">
                      {translations[this.props.lang]["Passport / Plates"]}:
                    </span>
                    {personTicket.PassportNumber}
                  </div>
                  <div className="col-md-1 col-xs-4 resultTick">
                    {personTicket.ConfirmationStatus === "N" ? (
                      <span>Non Show</span>
                    ) : null}
                    {personTicket.ConfirmationStatus === "A" ? (
                      <span>New</span>
                    ) : null}
                    {personTicket.ConfirmationStatus === "P" ? (
                      <span>Printed</span>
                    ) : null}
                    {personTicket.ConfirmationStatus === "C" ? (
                      <span>Cancelled</span>
                    ) : null}
                    {personTicket.ConfirmationStatus === "T" ? (
                      <span>Transferred</span>
                    ) : null}
                    {personTicket.ConfirmationStatus === "S" ? (
                      <span>Non Show</span>
                    ) : null}
                  </div>
                  <div className="col-md-12 tripData">
                    <div className="col-md-4 col-xs-4 float-sm-left resultTickBold">
                      {this.props.tripDataPerson[index].CompanyDescription}
                      {"/"}
                      {this.props.tripDataPerson[index].VesselName}
                    </div>
                    <div className="col-md-4 col-xs-4 float-sm-left resultTickBold">
                      {this.props.tripDataPerson[index].ArrivalPortDescription}
                    </div>
                    <div className="col-md-4 col-xs-4 float-sm-left resultTickBold">
                      {this.props.tripDataPerson[index].DepartureDate.substr(
                        -2
                      )}
                      {"/"}
                      {this.props.tripDataPerson[index].DepartureDate.substr(
                        -4,
                        2
                      )}
                      {"/"}
                      {this.props.tripDataPerson[index].DepartureDate.substr(
                        0,
                        4
                      )}
                      {" - "}
                      {this.props.tripDataPerson[index].DepartureTime.substr(
                        0,
                        2
                      )}
                      {":"}
                      {this.props.tripDataPerson[index].DepartureTime.substr(
                        2,
                        2
                      )}
                    </div>
                  </div>
                  <div className="col-md-6 leftStay">
                    {personTicket.ConfirmationStatus !== "Canceled" ? (
                      <FormGroup bsSize="large" className="left">
                        <ControlLabel>
                          {translations[this.props.lang]["Email Address"]}
                        </ControlLabel>
                        <FormControl
                          className="well"
                          value={this.props.ticketEmails[index]}
                          name="ticketEmail"
                          type="text"
                          maxLength={50}
                          onChange={event => {
                            this.props.handleChangeOfInputTicketEmail(
                              event,
                              index
                            );
                          }}
                        />
                      </FormGroup>
                    ) : (
                      <FormGroup bsSize="large" className="left">
                        <ControlLabel>
                          {translations[this.props.lang]["Email Address"]}
                        </ControlLabel>
                        <FormControl
                          className="well"
                          disabled
                          value={this.props.ticketEmails[index]}
                          name="ticketEmail"
                          type="text"
                          maxLength={50}
                          onChange={event => {
                            this.props.handleChangeOfInputTicketEmail(
                              event,
                              index
                            );
                          }}
                        />
                      </FormGroup>
                    )}
                  </div>
                  <div className="col-md-6">
                    {personTicket.ConfirmationStatus !== "Canceled" ? (
                      <FormGroup bsSize="large" className="left">
                        <ControlLabel>
                          {translations[this.props.lang]["Phone Number"]}
                        </ControlLabel>
                        <FormControl
                          className="well"
                          value={this.props.ticketPhoneNumbers[index]}
                          name="ticketPhone"
                          type="text"
                          maxLength={20}
                          onChange={event => {
                            this.props.handleChangeOfInputTicketPhone(
                              event,
                              index
                            );
                          }}
                        />
                      </FormGroup>
                    ) : (
                      <FormGroup bsSize="large" className="left">
                        <ControlLabel>
                          {translations[this.props.lang]["Phone Number"]}
                        </ControlLabel>
                        <FormControl
                          className="well"
                          disabled
                          value={this.props.ticketPhoneNumbers[index]}
                          name="ticketPhone"
                          type="text"
                          maxLength={20}
                          onChange={event => {
                            this.props.handleChangeOfInputTicketPhone(
                              event,
                              index
                            );
                          }}
                        />
                      </FormGroup>
                    )}
                  </div>
                </div>
              );
            })}
            {vehicleArraySize > 0 ? (
              <div className="col-md-12 head ticketOptions HeadTicks">
                <div className="col-md-2 reservationHeader">
                  {translations[this.props.lang]["Ticket Number"]}
                </div>
                <div className="col-md-3 reservationHeader">
                  {translations[this.props.lang]["Driver Name"]}
                </div>
                <div className="col-md-2 reservationHeader">
                  {translations[this.props.lang]["Plates"]}
                </div>
                <div className="col-md-1 reservationHeader">
                  {translations[this.props.lang]["Status"]}
                </div>
              </div>
            ) : null}
            {this.props.vehicleTickets.map((vehicleTicket, index) => {
              return (
                <div
                  className="col-md-12 col-xs-12 resultsRTicks"
                  key={vehicleTicket.BookID}
                >
                  <div className="col-md-1 col-xs-1 selectCol">
                    {vehicleTicket.ConfirmationStatus !== "Canceled" ? (
                      <Checkbox
                        color="primary"
                        checked={this.props.selectedVehicleTickets[index]}
                        onClick={() => {
                          this.props.handleVehicleCheckboxChange(index);
                        }}
                      />
                    ) : (
                      <Checkbox
                        color="primary"
                        disabled
                        checked={this.props.selectedVehicleTickets[index]}
                        onClick={() => {
                          this.props.handleVehicleCheckboxChange(index);
                        }}
                      />
                    )}
                  </div>
                  <div className="col-md-2 col-xs-4 resultTick">
                    <span className="rowdescr">
                      {translations[this.props.lang]["Ticket Number"]}:
                    </span>
                    {vehicleTicket.TicketNumber}
                  </div>
                  <div className="col-md-4 col-xs-4 resultTick">
                    <span className="rowdescr">
                      {translations[this.props.lang]["Driver Name"]}:
                    </span>
                    {vehicleTicket.DriverName}
                  </div>
                  <div className="col-md-3 col-xs-4 resultTick">
                    <span className="rowdescr">
                      {translations[this.props.lang]["Plates"]}:
                    </span>
                    {vehicleTicket.RegistrationNumber}
                  </div>
                  <div className="col-md-1 col-xs-4 resultTick">
                    {vehicleTicket.ConfirmationStatus === "N" ? (
                      <span>Non Show</span>
                    ) : null}
                    {vehicleTicket.ConfirmationStatus === "A" ? (
                      <span>New</span>
                    ) : null}
                    {vehicleTicket.ConfirmationStatus === "P" ? (
                      <span>Printed</span>
                    ) : null}
                    {vehicleTicket.ConfirmationStatus === "C" ? (
                      <span>Cancelled</span>
                    ) : null}
                    {vehicleTicket.ConfirmationStatus === "T" ? (
                      <span>Transferred</span>
                    ) : null}
                    {vehicleTicket.ConfirmationStatus === "S" ? (
                      <span>Non Show</span>
                    ) : null}
                  </div>
                  {this.props.tripDataVehicle.length > 0 ? (
                    <div className="col-md-12 tripData">
                      <div className="col-md-4 col-xs-4 float-sm-left resultTickBold">
                        {this.props.tripDataVehicle[index].CompanyDescription}
                        {"/"}
                        {this.props.tripDataVehicle[index].VesselName}
                      </div>
                      <div className="col-md-4 col-xs-4 float-sm-left resultTickBold">
                        {
                          this.props.tripDataVehicle[index]
                            .ArrivalPortDescription
                        }
                      </div>
                      <div className="col-md-4 col-xs-4 float-sm-left resultTickBold">
                        {this.props.tripDataVehicle[index].DepartureDate.substr(
                          -2
                        )}
                        {"/"}
                        {this.props.tripDataVehicle[index].DepartureDate.substr(
                          -4,
                          2
                        )}
                        {"/"}
                        {this.props.tripDataVehicle[index].DepartureDate.substr(
                          0,
                          4
                        )}
                        {" - "}
                        {this.props.tripDataVehicle[index].DepartureTime.substr(
                          0,
                          2
                        )}
                        {":"}
                        {this.props.tripDataVehicle[index].DepartureTime.substr(
                          2,
                          2
                        )}
                      </div>
                    </div>
                  ) : null}
                  <div className="col-md-6 leftStay">
                    {vehicleTicket.ConfirmationStatus !== "Canceled" ? (
                      <FormGroup bsSize="large" className="left">
                        <ControlLabel>
                          {translations[this.props.lang]["Email Address"]}
                        </ControlLabel>
                        <FormControl
                          className="well"
                          value={this.props.ticketVehicleEmails[index]}
                          name="ticketEmail"
                          type="text"
                          maxLength={50}
                          onChange={event => {
                            this.props.handleChangeOfInputTicketVehicleEmail(
                              event,
                              index
                            );
                          }}
                        />
                      </FormGroup>
                    ) : (
                      <FormGroup bsSize="large" className="left">
                        <ControlLabel>
                          {translations[this.props.lang]["Email Address"]}
                        </ControlLabel>
                        <FormControl
                          className="well"
                          disabled
                          value={this.props.ticketVehicleEmails[index]}
                          name="ticketEmail"
                          type="text"
                          maxLength={50}
                          onChange={event => {
                            this.props.handleChangeOfInputTicketVehicleEmail(
                              event,
                              index
                            );
                          }}
                        />
                      </FormGroup>
                    )}
                  </div>
                  <div className="col-md-6">
                    {vehicleTicket.ConfirmationStatus !== "Canceled" ? (
                      <FormGroup bsSize="large" className="left">
                        <ControlLabel>
                          {translations[this.props.lang]["Phone Number"]}
                        </ControlLabel>
                        <FormControl
                          className="well"
                          value={this.props.ticketVehiclePhoneNumbers[index]}
                          name="ticketPhone"
                          type="text"
                          maxLength={20}
                          onChange={event => {
                            this.props.handleChangeOfInputTicketVehiclePhone(
                              event,
                              index
                            );
                          }}
                        />
                      </FormGroup>
                    ) : (
                      <FormGroup bsSize="large" className="left">
                        <ControlLabel>
                          {translations[this.props.lang]["Phone Number"]}
                        </ControlLabel>
                        <FormControl
                          className="well"
                          disabled
                          value={this.props.ticketVehiclePhoneNumbers[index]}
                          name="ticketPhone"
                          type="text"
                          maxLength={20}
                          onChange={event => {
                            this.props.handleChangeOfInputTicketVehiclePhone(
                              event,
                              index
                            );
                          }}
                        />
                      </FormGroup>
                    )}
                  </div>
                </div>
              );
            })}
            <div className="col-12 leftStay">
              <div className="col-md-4 bot">
                <Button
                  className="btn btn-primary checkin btn btn-lg"
                  bsSize="large"
                  type="button"
                  disabled={this.props.disableIssueBoardingPassesButton}
                  onClick={() => this.props.confirmOpenTickets()}
                >
                  {translations[this.props.lang]["Confirm Open Tickets"]}
                </Button>
              </div>
              <div className="col-md-4 bot">
                <Button
                  className="btn btn-primary checkin btn btn-lg"
                  bsSize="large"
                  type="button"
                  disabled={this.props.disableIssueBoardingPassesButton}
                  onClick={() => this.props.cancelOpenTickets()}
                >
                  {translations[this.props.lang]["Cancel"]}
                </Button>
              </div>
              <div className="col-md-4 bot">
                <Button
                  className="btn btn-primary checkin btn btn-lg"
                  bsSize="large"
                  type="button"
                  disabled={this.props.disableIssueBoardingPassesButton}
                  onClick={() => this.props.changeTrip()}
                >
                  {translations[this.props.lang]["Change Trip"]}
                </Button>
              </div>
              {/*<div className="col-md-3 bot">
                <Button
                  className="btn btn-primary checkin btn btn-lg"
                  bsSize="large"
                  type="button"
                  disabled={this.props.disableIssueBoardingPassesButton}
                  onClick={() =>
                    this.props.issueBoardingPassesAndConfirmOpenTickets()
                  }
                >
                  {
                    translations[this.props.lang][
                      "Confirm Open Tickets And Issue Boarding Cards"
                    ]
                  }
                </Button>
              </div>*/}
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/confirmOpenTicketComponents/ReservationDetails.js